<template>
  <div class="mk-valid-input-wrap">
    <input
      v-model="inputValue"
      :id="inputID"
      :type="inputType"
      :class="inputClass"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :hidden="hidden"
      :min="min"
      :max="max"
      :maxlength="maxlength"
    />
    <div id="errorMessage" v-show="errorMessage" class="mk-valid-input-message">{{ errorMessage }}</div>
  </div>
</template>

<script setup>
// TODO: add radio input
  import { ref, defineProps, defineEmits, defineExpose, computed, watch } from 'vue';

  const props = defineProps({
    inputClass: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    },
    validationCallback: {
      type: Function
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    maxlength: {
      type: Number
    }
  })

  const emit = defineEmits(['update:value']);

  const inputID = computed(() => {
    return props.name;
  })

  const inputType = computed(() => {
    switch (props.type) {
      case 'integer':
        return 'number';
      case 'number':
        return 'number';
      case 'plainText':
        return 'text';
      default:
        return 'text';
    }
  })

  const inputValue = computed({
    get: () => props.value,
    set: (newV) => emit('update:value', newV)
  })

  const inputClass = computed(() => {
    let fixedClass = ["mk-valid-input"];
    if (props.inputClass) fixedClass.push(props.inputClass);
    if (props.type == 'password') fixedClass.push("password-field");

    return fixedClass.join(" ");
  })

  const errorMessage = ref('');
  const valid = ref(false);
  const showStyle = ref(false);

  watch(() => props.value, (newV) => {
    if (newV === null || newV === '') emit('update:value', '');
    validate();
  })

  watch(() => inputValue.value, (newV) => {
    // 針對input做限制
    switch (props.type) {
      case "plainText": // 只接受中英數
        inputValue.value = newV.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '');
        break;
      default:
        break;
    }
  })

  const errorTranslate = {
    "integer": "請填入正整數",
    "required": "必填",
  }

  const validate = () => {
    if (props.required && (props.value === '' || props.value === null)) {
      valid.value = false;
      errorMessage.value = errorTranslate["required"]
    } else if (props.required || props.value) {
      let regex
      switch (props.type) {
        case "integer":
          regex = /^[-]?[1-9]\d*$|^0$/
          break;
        default:
          regex = /^.*$/
          break;
      }

      valid.value = regex.test(props.value);
      errorMessage.value = valid.value ? "" : errorTranslate[props.type];
    } else {
      valid.value = true;
      errorMessage.value = "";
    }

    return valid.value;
  }


  defineExpose({
    validate: validate
  });
</script>

<style lang="scss" scoped>
  input.password-field {
    -webkit-text-security: disc !important;
  }

  $mk-valid-input-font-color: #212529;
  $mk-valid-input-invalid-border-color: #dc3545;
  $mk-valid-input-font-plcaeholder-color: #a2a2a2;
  .mk-valid-input-wrap {
    height: 60px; // 包含mk-valid-input-message
  }

  .mk-valid-input {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: $mk-valid-input-font-color;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0.125rem;

    &:disabled {
      background-color: #f8f9fa;
    }

    &:focus {
      color: $mk-valid-input-font-color;
      background-color: #fff;
      border-color: #4D4D4D;
      outline: 0;
      box-shadow: none;
    }

    &::placeholder {
      color: $mk-valid-input-font-plcaeholder-color;
      font-size: .9rem;
    }

    &--invalid {
      border-color: $mk-valid-input-invalid-border-color;
      &:focus {
        border-color: $mk-valid-input-invalid-border-color;
      }
    }
  }

  .mk-valid-input-message {
    padding-left: 0.5rem;
    padding-top: 0.25rem;
    color: red;
    font-size: 0.8rem;
  }
</style>
